import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './Pages.css';

function BusinessAnalysis() {
  const { t } = useTranslation();

  return (
    <div className="main-bg">
      <Header />
      <div className="page-container">
        <div className="page-header">
          <h1>{t('services.service6.title')}</h1>
          <div className="page-bar"></div>
        </div>
        
        <div className="page-content">
          <div className="service-detail">
            <div className="service-description">
              <h2>Përshkrimi i Shërbimit</h2>
              <p>{t('services.service6.desc')}</p>
              <p>Shërbimi ynë i analizës së biznesit përfshin:</p>
              <ul>
                <li>Analizë e performancës së biznesit</li>
                <li>Identifikimi i mundësive të rritjes</li>
                <li>Vlerësimi i konkurrencës dhe tregut</li>
                <li>Optimizimi i proceseve të biznesit</li>
                <li>Strategji për përmirësimin e fitimit</li>
              </ul>
            </div>
            
            <div className="service-benefits">
              <h2>Përfitimet</h2>
              <div className="benefits-grid">
                <div className="benefit-card">
                  <h3>Insight të Thellë</h3>
                  <p>Kuptim i plotë i performancës së biznesit</p>
                </div>
                <div className="benefit-card">
                  <h3>Identifikimi i Mundësive</h3>
                  <p>Zbulimi i zonave për rritje dhe përmirësim</p>
                </div>
                <div className="benefit-card">
                  <h3>Vendimmarrje e Bazuar në Të Dhëna</h3>
                  <p>Strategji të informuara për zhvillimin e biznesit</p>
                </div>
                <div className="benefit-card">
                  <h3>Rritje e Fitimit</h3>
                  <p>Optimizimi i operacioneve për rezultate më të mira</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default BusinessAnalysis; 